import React from 'react';
import { ProgressContainerStyled, ProgressBarOuterStyled, ProgressBarStyled } from '../styles/Indicator';

function ProgressBar(props) {
    return (
        <ProgressContainerStyled>
            <ProgressBarOuterStyled>
                <ProgressBarStyled $progress={Number(props.step)/Number(props.totalSteps)}/>
            </ProgressBarOuterStyled>
                              
        </ProgressContainerStyled>
    );
}

export default ProgressBar;